export { default } from "./useUserTermsOfServicePost";
